import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchOrganization } from '../../../api';
import { updateOrganization } from '../all/actions';

export const coreOrganizationsByIdPatchAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ updateOrganization ]
	},
	name: 'CoreOrganizationsById',
	receive: false,
	request: true,
	requestHandler: patchOrganization
});
